import { get } from '@/api/fetch';
import { mapAuth0User } from '@/helpers/authUtils';
import { Store } from 'vuex';

export async function setMockUser(store: Store<any>): Promise<void> {
  if (import.meta.env.VUE_APP_MOCK_AUTH === 'ui-tests') {
    const response = await get('/api/mockUser');
    const userJson = await response.json();
    const authenticatedUser = mapAuth0User(userJson);
    await store.dispatch('setUserData', authenticatedUser);
    await store.dispatch('setUserDetails', authenticatedUser?.auth0Id);
    await store.dispatch('getAgencies');
    await store.dispatch('switchToAgency');
  }
}
